export default "__VITE_ASSET__C1UU_9$t__"